<template>
  <aside class="main_content" id="main_content_div">
    <section class="content" v-if="$store.state.auth.me.roles.includes('client_sub') || $store.state.auth.me.roles.includes('client_sub')">
      <div class="card test p-3">
        <slot></slot>
      </div>
    </section>
    <section class="content" v-else>
      <slot></slot>
    </section>
  </aside>
</template>

<script>
import {mapState, mapActions} from 'vuex'

export default {
  name: 'main_content',
  beforeMount() {
    this.load_crm().then(() => this.$store.commit('COMMIT_CRM_LOADED', true));
    this.load_note_types(this.$store.state.auth.me.rel_profile.division_id);
  },
  computed: {
    ...mapState({me: state => state.auth.me})
  },
  methods: {
    ...mapActions([
      'login',
      'load_pay_cycle',
      'load_timesheet_cycle',
      'load_payment_term',
      'load_vat_percentage',
      'load_rate_type',
      'load_pay_type',
      'load_person_title',
      'load_worker_employment_type',
      'load_utr_status',
      'load_fee_type',
      'load_worker_bank_type',
      'load_company_address_type',
      'load_worker_address_type',
      'load_company_phone_type',
      'load_contact_phone_type',
      'load_worker_phone_type',
      'load_company_email_type',
      'load_contact_email_type',
      'load_worker_email_type',
      'load_recruitment_order_type',
      'load_payroll_client_solution',
      'load_payroll_trading_company',
      'load_payroll_order_type',
      'load_worker_application_status',
      'load_news_article_category',
      'load_company_type',
      'load_company_pipeline_status',
      'load_company_pipeline_opportunity_size',
      'load_divisions',
      'load_job_titles',
      'load_nationalities',
      'load_qualifications',
      'load_recruitment_departments',
      'load_relationships',
      'load_sectors',
      'load_note_types',
      'load_file_types',
      'load_worker_recruitment_job_types'
    ]),
    load_crm() {
      let crm_promises = [];
      //
      // CRM Attributes
      //
      crm_promises.push(new Promise(loaded => {
        this.load_pay_cycle();
        this.load_timesheet_cycle();
        this.load_payment_term();
        this.load_vat_percentage();
        this.load_rate_type();
        this.load_pay_type();
        this.load_person_title();
        this.load_worker_employment_type();
        this.load_utr_status();
        this.load_fee_type();
        this.load_worker_bank_type();
        this.load_company_address_type();
        this.load_worker_address_type();
        this.load_company_phone_type();
        this.load_contact_phone_type();
        this.load_worker_phone_type();
        this.load_company_email_type();
        this.load_contact_email_type();
        this.load_worker_email_type();
        this.load_recruitment_order_type();
        this.load_payroll_client_solution();
        this.load_payroll_trading_company();
        this.load_payroll_order_type();
        this.load_worker_application_status();
        this.load_news_article_category();
        this.load_company_type();
        this.load_company_pipeline_status();
        this.load_company_pipeline_opportunity_size();
        this.load_worker_recruitment_job_types();
        this.load_file_types();

        loaded();
      }));
      //
      // CRM
      //
      crm_promises.push(new Promise(loaded => {
        this.load_divisions();
        this.load_job_titles();
        this.load_nationalities();
        this.load_qualifications();
        this.load_recruitment_departments();
        this.load_relationships();
        this.load_sectors();

        loaded();
      }));
      return Promise.all(crm_promises)
    }
  }
}
</script>
<style scoped lang="scss">
.main_content {
  display:          flex;
  vertical-align:   top;
  transition:       all 0.3s;
  padding:          $tm_height 0 0 $sb_width;
  width:            100%;

  max-width:        100%;
  background-color: $main_content_background !important;

  .test {
    min-height: calc(100vh - 70px);
  }

  .content {
    padding:    15px;
    width:      100%;
    min-height: calc(100vh - 40px);
  }
}

.main_content {
  &.expanded_sidebar {
    padding-left: $sb_expanded_width;
  }

  &.show_main_content {
    width: calc(100% - 400px);
    left:  0;
  }
}
</style>
